import Swal from 'sweetalert2/dist/sweetalert2';

var config = {
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 45000,
  timerProgressBar: true,
  didOpen: toast => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  }
};

export default {
  'success': function (message) {
    Swal.mixin(config).fire({
      icon: "success",
      width: "32rem",
      title: message || "Success. :)"
    });
  },
  'error': function (message = {}) {
    Swal.mixin(config).fire({
      icon: "error",
      width: "32rem",
      title: message || "Error. :("
    });
  },
  'info': function (message = {}) {
    Swal.mixin(config).fire({
      icon: "info",
      width: "32rem",
      title: message || "Info. !!!"
    });
  }
}